"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fiats = [
    {
        fiat_code: "AED",
        fiat_name: "United Arab Emirates Dirham",
        fiat_symbol: "AED",
    },
    {
        fiat_code: "AUD",
        fiat_name: "Australian Dollar",
        fiat_symbol: "AU$",
    },
    {
        fiat_code: "BRL",
        fiat_name: "Brazilian Real",
        fiat_symbol: "R$",
    },
    {
        fiat_code: "CAD",
        fiat_name: "Canadian Dollar",
        fiat_symbol: "CA$",
    },
    {
        fiat_code: "CHF",
        fiat_name: "Swiss Franc",
        fiat_symbol: "CHF",
    },
    {
        fiat_code: "CLP",
        fiat_name: "Chilean Peso",
        fiat_symbol: "CL$",
    },
    {
        fiat_code: "COP",
        fiat_name: "Colombian Peso",
        fiat_symbol: "CO$",
    },
    {
        fiat_code: "CZK",
        fiat_name: "Czech Republic Koruna",
        fiat_symbol: "Kč",
    },
    {
        fiat_code: "DKK",
        fiat_name: "Danish Krone",
        fiat_symbol: "Dkr",
    },
    {
        fiat_code: "EUR",
        fiat_name: "Euro",
        fiat_symbol: "€",
    },
    {
        fiat_code: "GBP",
        fiat_name: "British Pound Sterling",
        fiat_symbol: "£",
    },
    {
        fiat_code: "HKD",
        fiat_name: "Hong Kong Dollar",
        fiat_symbol: "HK$",
    },
    {
        fiat_code: "IDR",
        fiat_name: "Indonesian Rupiah",
        fiat_symbol: "Rp",
    },
    {
        fiat_code: "INR",
        fiat_name: "Indian Rupee",
        fiat_symbol: "Rs",
    },
    {
        fiat_code: "JPY",
        fiat_name: "Japanese Yen",
        fiat_symbol: "¥",
    },
    {
        fiat_code: "KRW",
        fiat_name: "South Korean Won",
        fiat_symbol: "₩",
    },
    {
        fiat_code: "MXN",
        fiat_name: "Mexican Peso",
        fiat_symbol: "MX$",
    },
    {
        fiat_code: "NGN",
        fiat_name: "Nigerian Naira",
        fiat_symbol: "₦",
    },
    {
        fiat_code: "NOK",
        fiat_name: "Norwegian Krone",
        fiat_symbol: "Nkr",
    },
    {
        fiat_code: "NZD",
        fiat_name: "New Zealand Dollar",
        fiat_symbol: "NZ$",
    },
    {
        fiat_code: "PHP",
        fiat_name: "Philippine Peso",
        fiat_symbol: "₱",
    },
    {
        fiat_code: "PLN",
        fiat_name: "Polish Zloty",
        fiat_symbol: "zł",
    },
    {
        fiat_code: "QAR",
        fiat_name: "Qatari Rial",
        fiat_symbol: "QR",
    },
    {
        fiat_code: "RON",
        fiat_name: "Romanian Leu",
        fiat_symbol: "RON",
    },
    {
        fiat_code: "SAR",
        fiat_name: "Saudi Riyal",
        fiat_symbol: "SR",
    },
    {
        fiat_code: "SEK",
        fiat_name: "Swedish Krona",
        fiat_symbol: "Skr",
    },
    {
        fiat_code: "SGD",
        fiat_name: "Singapore Dollar",
        fiat_symbol: "S$",
    },
    {
        fiat_code: "THB",
        fiat_name: "Thai Baht",
        fiat_symbol: "฿",
    },
    {
        fiat_code: "TRY",
        fiat_name: "Turkish Lira",
        fiat_symbol: "TL",
    },
    {
        fiat_code: "TWD",
        fiat_name: "New Taiwan Dollar",
        fiat_symbol: "NT$",
    },
    {
        fiat_code: "USD",
        fiat_name: "US Dollar",
        fiat_symbol: "$",
    },
    {
        fiat_code: "VND",
        fiat_name: "Vietnamese Dong",
        fiat_symbol: "₫",
    },
    {
        fiat_code: "ZAR",
        fiat_name: "South African Rand",
        fiat_symbol: "R",
    },
];
exports.default = fiats;
//# sourceMappingURL=fiats.js.map